var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareerSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.51,342.55c7.38-4.66,10.07-10.69,11.29-19.34a30.59,30.59,0,0,0-7.36-24.28c-4.84-5.44-11.68-9.17-15.18-15.55-3.72-6.81-3.17-15.82-8.52-21.43-3.68-3.85-9.26-5.1-13.82-7.86-3.72-2.25-6.72-5.49-10.09-8.24s-7.42-5.08-11.77-5c-6.55.19-11.94,6.37-12.55,12.9s2.75,13,7.55,17.44c3.48,3.24,7.83,5.8,10,10,4.1,7.94-1.06,18.47,3.38,26.22,3.24,5.67,11,8.67,11.84,15.15.3,2.38-.48,4.76-.57,7.16-.3,7.5,6.43,13.86,13.75,15.53s14.95-.29,22-2.77",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,267.9a5.47,5.47,0,0,0,.74.91l2.26,2.5c1,1.06,2.21,2.38,3.51,4s2.9,3.36,4.43,5.48l2.47,3.26c.86,1.14,1.65,2.39,2.53,3.65,1.78,2.49,3.44,5.32,5.25,8.26A160.17,160.17,0,0,1,132,316.09a159,159,0,0,1,6.59,21.42c.69,3.38,1.41,6.58,1.81,9.62.22,1.51.49,3,.65,4.39s.28,2.77.42,4.07c.33,2.59.37,5,.5,7s.17,3.86.17,5.32,0,2.5.05,3.36a5.75,5.75,0,0,0,.08,1.18,6.29,6.29,0,0,0,.1-1.17c0-.86.07-2,.12-3.37s.09-3.26,0-5.34-.08-4.45-.37-7.06c-.12-1.3-.24-2.67-.37-4.09s-.39-2.9-.6-4.42c-.37-3.07-1.06-6.29-1.74-9.69a152.15,152.15,0,0,0-6.56-21.57,152.49,152.49,0,0,0-9.93-20.23c-1.84-2.94-3.53-5.77-5.35-8.26-.89-1.26-1.71-2.51-2.58-3.64l-2.53-3.24c-1.57-2.1-3.19-3.84-4.55-5.42s-2.59-2.87-3.63-3.9l-2.39-2.38A6,6,0,0,0,101,267.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.94,174.32s-9.4-6.22-20.85,16.27S662.29,226,662.29,226s-3,4.71-6.27,1.63-7.67-11.82-13.17-10.24c-5.7,1.63-7.58,8-6.49,17.35s2.72,29.94,2.86,31.8-.91,4.52-3.45,2.77-17.16-18-24.46-10.62,0,33,.75,35.77.19,4-1.14,4.7-5.73-5.23-10.08-9.69-10.17-8.87-14-4.25-5.09,23.8,13.16,55l9.41,13.88,16.81-.93c35.87-4.19,50.43-16.73,51.8-22.59s-5.66-7.86-11.84-8.64-13.56-.72-13.81-2.21.38-2.64,3.07-3.74,27.51-10.66,29-20.94-20.29-12.16-23.21-13.14-1.41-3.43.14-4.42,19-12.1,27.1-16.87,12.08-10.1,9.95-15.63c-2.06-5.34-11.7-3.62-16.11-4.35s-2.47-6-2.47-6,7.74-11.28,18.78-34,.14-26.49.14-26.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.65,194.44l-.21.48-.66,1.41-2.57,5.38c-2.24,4.68-5.52,11.42-9.62,19.73-8.18,16.63-19.67,39.51-32.44,64.74s-24.32,48.08-32.58,64.67L600.8,370.5l-2.66,5.34-.7,1.38a4.85,4.85,0,0,1-.26.47l.21-.49.66-1.4,2.57-5.39c2.24-4.67,5.52-11.41,9.62-19.73,8.18-16.63,19.67-39.51,32.45-64.74s24.31-48.07,32.57-64.66L685,201.63l2.66-5.35.7-1.38C688.55,194.59,688.65,194.44,688.65,194.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.56,229.9A5.07,5.07,0,0,1,649,231c.25.74.57,1.82.95,3.16.76,2.68,1.71,6.41,2.69,10.55l2.47,10.59c.3,1.27.56,2.34.77,3.2a5.13,5.13,0,0,1,.23,1.19,6.13,6.13,0,0,1-.43-1.13c-.24-.74-.56-1.83-.93-3.17-.73-2.69-1.64-6.43-2.62-10.56s-1.86-7.75-2.54-10.57l-.78-3.2A5.92,5.92,0,0,1,648.56,229.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.63,260c0-.14,7.56-2.44,17-5.15s17.08-4.79,17.12-4.65-7.56,2.44-17,5.15S657.67,260.16,657.63,260Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.27,297.88a5.71,5.71,0,0,1,1.23-.06l3.37,0c2.84,0,6.76,0,11.09-.18s8.24-.43,11.07-.66l3.36-.26a5.35,5.35,0,0,1,1.24,0,5.4,5.4,0,0,1-1.22.24c-.79.12-1.93.27-3.34.43-2.83.32-6.75.66-11.09.81s-8.27.12-11.12,0c-1.42-.05-2.57-.11-3.36-.17A5.13,5.13,0,0,1,636.27,297.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.06,272.44a3.92,3.92,0,0,1,.66.94l1.62,2.65c1.35,2.25,3.19,5.38,5.19,8.86s3.78,6.63,5.05,8.93l1.47,2.74a5.18,5.18,0,0,1,.49,1,4.22,4.22,0,0,1-.66-.94L634.26,294c-1.35-2.25-3.19-5.38-5.19-8.85s-3.78-6.64-5.05-8.94l-1.47-2.73A5.49,5.49,0,0,1,622.06,272.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599,303.46a9.81,9.81,0,0,1,.83,1.21c.54.89,1.24,2,2.09,3.4,1.74,2.87,4.13,6.87,6.73,11.3s4.93,8.45,6.6,11.37c.79,1.41,1.44,2.58,1.95,3.48a7.85,7.85,0,0,1,.65,1.31,8.1,8.1,0,0,1-.83-1.21l-2.09-3.39c-1.74-2.88-4.13-6.87-6.73-11.3s-4.93-8.45-6.6-11.38l-1.95-3.47A7.67,7.67,0,0,1,599,303.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.58,334.64a8.82,8.82,0,0,1,1.56-.11l4.27-.14c3.6-.12,8.57-.31,14.06-.67s10.45-.8,14-1.15l4.25-.42a8.75,8.75,0,0,1,1.57-.09,8.46,8.46,0,0,1-1.54.29c-1,.16-2.45.36-4.24.58-3.58.45-8.54,1-14,1.31s-10.48.49-14.08.52c-1.81,0-3.27,0-4.28,0A8,8,0,0,1,617.58,334.64Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698.4,458.17c0,.15-143.22.27-319.84.27s-319.87-.12-319.87-.27,143.19-.26,319.87-.26S698.4,458,698.4,458.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.13,388.43a13.79,13.79,0,0,1,9.6,5,24.37,24.37,0,0,1,4.83,9.93c1.79,7,.58,15.15-1.46,22-7.49-2.75-12.06-10.81-14.12-15-3.25-6.69-5.07-20.76,1.15-21.95",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,433.93a11.79,11.79,0,0,1-.45-11.85,15.64,15.64,0,0,1,9.5-7.51c1.84-.55,4-.77,5.56.31a5,5,0,0,1,1.9,4.75,10.19,10.19,0,0,1-2.2,4.84c-3.7,4.92-8.18,9-14.31,9.46",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47,457.13a9.69,9.69,0,0,1-.32-1.44c-.19-1-.44-2.36-.74-4-.56-3.33-1.46-8.07-.71-13.29a25.37,25.37,0,0,1,5-12.28,16.72,16.72,0,0,1,2.88-2.85,7.71,7.71,0,0,1,.9-.64q.32-.21.33-.18a27,27,0,0,0-3.82,3.9,26.24,26.24,0,0,0-4.81,12.12c-.75,5.12.08,9.82.55,13.17.26,1.68.46,3,.58,4A6.72,6.72,0,0,1,112.47,457.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.46,399a3,3,0,0,1,.3.58c.2.43.45,1,.76,1.68.65,1.46,1.57,3.59,2.68,6.23,2.22,5.27,5.18,12.61,8.27,20.78s5.72,15.64,7.54,21.06c.92,2.72,1.64,4.92,2.12,6.45l.54,1.76a2.45,2.45,0,0,1,.15.62,3.29,3.29,0,0,1-.25-.59c-.17-.44-.38-1-.64-1.73-.55-1.57-1.32-3.73-2.26-6.39-1.92-5.39-4.6-12.83-7.69-21S96,413,93.86,407.64l-2.53-6.3c-.27-.7-.49-1.27-.67-1.71A3.34,3.34,0,0,1,90.46,399Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68,441.71a27.59,27.59,0,0,0-21.32-13.5c-2.22-.18-4.89.17-5.9,2.15s.3,4.37,1.8,6a23.59,23.59,0,0,0,25.5,5.93",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7,434.18a7.64,7.64,0,0,1,1.39.07,13.35,13.35,0,0,1,1.62.2,19.72,19.72,0,0,1,2.12.42,24.28,24.28,0,0,1,2.53.72,28,28,0,0,1,2.81,1.1,30.43,30.43,0,0,1,5.92,3.58,30.08,30.08,0,0,1,4.88,4.9,26.56,26.56,0,0,1,1.71,2.5A23.59,23.59,0,0,1,110,450a18.42,18.42,0,0,1,.86,2,10.7,10.7,0,0,1,.54,1.54,6.47,6.47,0,0,1,.35,1.35c-.11,0-.63-1.89-2.08-4.71a23.91,23.91,0,0,0-1.31-2.25,29.64,29.64,0,0,0-1.72-2.42,30.78,30.78,0,0,0-4.82-4.79,31.33,31.33,0,0,0-5.8-3.55A27.62,27.62,0,0,0,93.22,436c-.87-.34-1.71-.56-2.48-.78C87.67,434.42,85.68,434.3,85.7,434.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.11,69.83H152.46a13.72,13.72,0,0,0-13.72,13.72V394.09a13.72,13.72,0,0,0,13.72,13.72H321.2s10.73,33.19-22.54,50.36H456.43s-37.56-12.87-27.91-50.36H592.11a13.72,13.72,0,0,0,13.72-13.72V83.55A13.72,13.72,0,0,0,592.11,69.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15,375.15c6,8.55-3.38,17.91-11.93,11.93a3,3,0,0,1-.73-.74c-6-8.54,3.38-17.89,11.93-11.92A2.82,2.82,0,0,1,378.15,375.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.66,
    y: 88.45,
    width: 446.34,
    height: 264.75,
    rx: 3.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.66,
    y: 107.84,
    width: 446.34,
    height: 245.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26,98.67a3.57,3.57,0,1,1-3.56-3.56A3.56,3.56,0,0,1,185.26,98.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66,98.67a3.57,3.57,0,1,1-3.57-3.56A3.56,3.56,0,0,1,163.66,98.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,98.67a3.57,3.57,0,1,1-3.57-3.56A3.56,3.56,0,0,1,174,98.67Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.58,
    y: 122.63,
    width: 117.54,
    height: 196.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "494.76 238.27 496.02 240.82 498.84 241.24 496.8 243.22 497.28 246.03 494.76 244.7 492.24 246.03 492.73 243.22 490.69 241.24 493.5 240.82 494.76 238.27",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.76 238.27 510.02 240.82 512.84 241.24 510.8 243.22 511.28 246.03 508.76 244.7 506.24 246.03 506.72 243.22 504.68 241.24 507.5 240.82 508.76 238.27",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "522.75 238.27 524.01 240.82 526.83 241.24 524.79 243.22 525.27 246.03 522.75 244.7 520.24 246.03 520.72 243.22 518.68 241.24 521.49 240.82 522.75 238.27",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "536.75 238.27 538.01 240.82 540.83 241.24 538.79 243.22 539.27 246.03 536.75 244.7 534.23 246.03 534.71 243.22 532.67 241.24 535.49 240.82 536.75 238.27",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "550.74 238.27 552 240.82 554.82 241.24 552.78 243.22 553.26 246.03 550.74 244.7 548.23 246.03 548.71 243.22 546.67 241.24 549.49 240.82 550.74 238.27",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.55,261.29c0,.15-8.92.26-19.93.26s-19.93-.11-19.93-.26,8.92-.26,19.93-.26S517.55,261.15,517.55,261.29Z",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.64,270c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.26,44.45-.26S567.64,269.8,567.64,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.64,277.38c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.26,44.45-.26S567.64,277.24,567.64,277.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.64,284.82c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.26,44.45-.26S567.64,284.67,567.64,284.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.64,292.25c0,.15-19.9.26-44.45.26s-44.45-.11-44.45-.26,19.9-.26,44.45-.26S567.64,292.11,567.64,292.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.64,299.69c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.26,44.45-.26S567.64,299.54,567.64,299.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.31,
    y: 132.6,
    width: 101.25,
    height: 97.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "557.52 212.86 564.1 229.81 548.16 229.81 544.57 220.58 557.52 212.86",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.83,229.81H540c.67-6.38,1.09-12.41,1.09-12.41l2.22,6,18.13-9.07s-6.59-17.57-12.11-23.52c-7-7.53-19.51-6.78-19.51-6.78l-16.28.27a37.82,37.82,0,0,0-12,3.5l-.4.12V188c-3.52,3-14.1,17.18-14.1,17.18l3.9,3.79,8,7.45a.19.19,0,0,0,0,.15C499,217.38,496.83,229.81,496.83,229.81Z",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.28,183.45s.05.1.09.29a5.56,5.56,0,0,1,.11.86,8.61,8.61,0,0,1-.44,3.16,9,9,0,0,1-2.65,3.93,8.93,8.93,0,0,1-10.95.31,9.09,9.09,0,0,1-2.86-3.78,8.56,8.56,0,0,1-.61-3.13,4.75,4.75,0,0,1,.06-.87c0-.19.05-.29.07-.29a11.44,11.44,0,0,0,.82,4.15,9,9,0,0,0,2.81,3.53,8.6,8.6,0,0,0,10.36-.29,8.88,8.88,0,0,0,2.6-3.68A11.25,11.25,0,0,0,530.28,183.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,187.31c0,.05-.44,0-1.15.3a5.63,5.63,0,0,0-2.52,1.9,9.13,9.13,0,0,0-1.63,4.41c-.24,1.79-.29,3.81-.37,5.91-.11,4.22.05,8,.25,10.8.09,1.29.18,2.38.24,3.26a4.86,4.86,0,0,1,.05,1.21,6.31,6.31,0,0,1-.25-1.18c-.11-.77-.27-1.88-.41-3.26a85.54,85.54,0,0,1-.4-10.84,57.05,57.05,0,0,1,.42-6,9.13,9.13,0,0,1,1.82-4.57,5.44,5.44,0,0,1,2.74-1.86,3.28,3.28,0,0,1,.89-.14C545.59,187.28,545.7,187.29,545.7,187.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,185.49a6.87,6.87,0,0,1-.3,1.22c-.27.88-.6,2-1,3.29-.83,2.77-1.94,6.61-3.06,10.89s-2,8.17-2.62,11c-.3,1.33-.55,2.45-.75,3.35a5.82,5.82,0,0,1-.33,1.22,7.15,7.15,0,0,1,.13-1.26c.12-.8.32-2,.58-3.38.54-2.86,1.38-6.78,2.49-11.06s2.29-8.12,3.21-10.87c.46-1.38.85-2.48,1.14-3.24A6.21,6.21,0,0,1,507,185.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.74,201l6,21.26-2.39,1.2-2.22-6S538.93,204.8,539.74,201Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.7,185.51c-3.47,1.76,5.05,6.32,8.94,6.28L514,184.23S508.86,184.92,507.7,185.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M522.35,193.24h0a8.61,8.61,0,0,1-9.19-8.92c.1-2.77.19-5,.19-5s-6.87-.6-7.41-7.39-.42-22.48-.42-22.48h0a23.68,23.68,0,0,1,23.94,1.39l1.06.7-.13,33.18A8.62,8.62,0,0,1,522.35,193.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.21,161.41a1,1,0,1,0-1.39,0A1,1,0,0,0,509.21,161.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.2,159.39c.11.11.74-.44,1.68-.51s1.65.37,1.74.24-.07-.26-.38-.47a2.37,2.37,0,0,0-1.41-.34,2.31,2.31,0,0,0-1.33.56C506.23,159.12,506.14,159.34,506.2,159.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.75,159.92a1,1,0,1,0,1.38.23A1,1,0,0,0,517.75,159.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.1,159.42c.12.11.75-.45,1.69-.52s1.64.37,1.74.24-.07-.26-.39-.46a2.21,2.21,0,0,0-1.4-.34,2.24,2.24,0,0,0-1.33.55C516.13,159.15,516.05,159.37,516.1,159.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.12,167.66a4.66,4.66,0,0,0-1.54-.21c-.25,0-.44-.06-.47-.19a1.33,1.33,0,0,1,.13-.71l.61-2a26.51,26.51,0,0,0,1.27-5.11,25.2,25.2,0,0,0-1.78,4.95c-.2.68-.39,1.33-.57,2a1.58,1.58,0,0,0-.07,1,.65.65,0,0,0,.45.37,1.25,1.25,0,0,0,.42,0A4.47,4.47,0,0,0,513.12,167.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.34,179.19a15.82,15.82,0,0,0,8.69-3.12s-1.77,5-8.59,4.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.22,158.74c.13-.05,5.56-.64,4.7,4.61-.74,4.53-5.62,3.15-5.61,3S530.22,158.74,530.22,158.74Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.21,164.35s.07.06.2.13a.8.8,0,0,0,.59.06,2,2,0,0,0,1-1.68,2.5,2.5,0,0,0-.13-1.14.93.93,0,0,0-.55-.65.41.41,0,0,0-.48.19c-.07.12,0,.21-.07.21s-.09-.08,0-.26a.54.54,0,0,1,.2-.27.59.59,0,0,1,.44-.08,1.09,1.09,0,0,1,.77.76,2.77,2.77,0,0,1,.18,1.27,2.05,2.05,0,0,1-1.29,1.86.84.84,0,0,1-.71-.17C531.21,164.46,531.19,164.36,531.21,164.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.08,163.46c-1.05.63-2.48-.16-3-1.26a8.9,8.9,0,0,1-.53-3.61,18.28,18.28,0,0,0-.86-4.92,3.45,3.45,0,0,0-5.29-2.52,8.37,8.37,0,0,1-3.53.88c-1.61-.14-2.94-1.41-4.55-1.63s-2.91.51-4.36.92a6.57,6.57,0,0,1-4.42-.1,3.76,3.76,0,0,1-2.35-3.51,2.67,2.67,0,0,1,3.11-2.43,2.17,2.17,0,0,1-.37-3.27,3.44,3.44,0,0,1,3.55-.71,9,9,0,0,1,3.16,2.07,2.55,2.55,0,0,1,2.42-2,5.31,5.31,0,0,1,3.2,1.09c1,.64,1.81,1.42,2.82,2,2,1.11,4.38,1.23,6.63,1.64s4.66,1.32,5.75,3.34c1,1.77.32,3.9.24,5.92s-.09,2.57-.19,4.54C530.49,159.83,530.62,162.57,529.08,163.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.27,170.41c0,.06.25.17.71.16a2.95,2.95,0,0,0,2.7-2c.14-.44.1-.72,0-.73s-.37,1-1.36,1.78A7,7,0,0,1,512.27,170.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.46,146.67a1,1,0,0,0-.41,1,1.74,1.74,0,0,0,.56,1.11,1.93,1.93,0,0,0,1.59.38,5.2,5.2,0,0,0,1.86-.75,8,8,0,0,1,2-1,3.43,3.43,0,0,1,2.38.36c.77.38,1.49.93,2.29,1.42a4.45,4.45,0,0,0,2.58.83,4.13,4.13,0,0,0,2.29-1.08,5.84,5.84,0,0,1,1.93-1.13,3.27,3.27,0,0,1,1.9.11,3.72,3.72,0,0,1,2.07,1.84,5,5,0,0,1,.29,1,2.38,2.38,0,0,0-.22-1,3.71,3.71,0,0,0-2.09-1.94,3.39,3.39,0,0,0-2-.14,5.59,5.59,0,0,0-2,1.15,4.17,4.17,0,0,1-2.2,1,4.28,4.28,0,0,1-2.47-.81c-.78-.48-1.51-1-2.31-1.42a3.62,3.62,0,0,0-2.5-.37,8.19,8.19,0,0,0-2,1,5.09,5.09,0,0,1-1.8.75,1.79,1.79,0,0,1-1.5-.33,1.69,1.69,0,0,1-.56-1A1.1,1.1,0,0,1,504.46,146.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.47,143.09a.49.49,0,0,0-.2-.17.86.86,0,0,0-.75,0,.94.94,0,0,0-.57,1,1.48,1.48,0,0,0,1,1.2,2.94,2.94,0,0,0,1.91-.09,11.88,11.88,0,0,1,2.07-.62,2.62,2.62,0,0,1,2.1.82,8.45,8.45,0,0,0,2,1.65,3.36,3.36,0,0,0,2.59-.15,9.31,9.31,0,0,1,2.27-.72,5.62,5.62,0,0,1,5.67,2.84c.32.57.42.92.44.91a3.93,3.93,0,0,0-.37-.94,5.62,5.62,0,0,0-1.83-2.06,5.71,5.71,0,0,0-3.94-.93,9.63,9.63,0,0,0-2.31.72,3.14,3.14,0,0,1-2.44.15,8.73,8.73,0,0,1-2-1.61,2.75,2.75,0,0,0-2.24-.86,10.79,10.79,0,0,0-2.1.65A2.85,2.85,0,0,1,507,145a1.34,1.34,0,0,1-.93-1.08.84.84,0,0,1,.5-.92.82.82,0,0,1,.7,0C507.41,143,507.46,143.1,507.47,143.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.55,148.41c.13.05.5-.77,1.38-1.31s1.76-.53,1.77-.67-.21-.16-.6-.17a2.82,2.82,0,0,0-2.44,1.53C527.5,148.15,527.49,148.39,527.55,148.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.35,143.38c-.14,0,.06,1.06-.11,2.31s-.59,2.19-.47,2.26a4.27,4.27,0,0,0,.58-4.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.94,161.61a2.35,2.35,0,0,0,.29-1.94,4.41,4.41,0,0,0-1.09-1.86,2.37,2.37,0,0,1-.52-1.08,3.28,3.28,0,0,1,.16-1.3,5.22,5.22,0,0,0,.15-2.64,2.89,2.89,0,0,0-1.21-1.78,2.39,2.39,0,0,0-1.4-.39,1.33,1.33,0,0,0-.52.13s.19,0,.52-.05a2.35,2.35,0,0,1,1.32.43,2.7,2.7,0,0,1,1.11,1.7,5.11,5.11,0,0,1-.16,2.55,3.4,3.4,0,0,0-.16,1.38,2.53,2.53,0,0,0,.57,1.16,4.38,4.38,0,0,1,1.09,1.78,3.19,3.19,0,0,1,0,1.41A2.67,2.67,0,0,1,529.94,161.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525,210a5.68,5.68,0,0,1,0,.65c0,.47,0,1,.05,1.72,0,1.48.09,3.56.11,6.07l-.06-.16,3.08,2.87-.26,0,5.3-2.15-.15.2a4.8,4.8,0,0,1,.09-.5c.58-3.15,1.12-6.12,1.6-8.7l.23.27c-2.95,0-5.43-.07-7.2-.11l-2.07-.06A4.47,4.47,0,0,1,525,210a4.44,4.44,0,0,1,.68-.05l2-.06c1.75,0,4.29-.1,7.34-.12h.27l0,.27c-.46,2.59-1,5.56-1.54,8.71l-.09.5,0,.14-.13.06-5.31,2.11-.15.06-.11-.11-3-2.91-.07-.07v-.09c0-2.6.07-4.74.11-6.2,0-.67,0-1.22.06-1.68A2.23,2.23,0,0,1,525,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.41,212.61a17.51,17.51,0,0,1-4.72.39,18,18,0,0,1-4.73-.36,27.38,27.38,0,0,1,4.73-.16A28,28,0,0,1,534.41,212.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.27,207.39c.21.21-16,22.42-16,22.42h15.89l9.75-13.36Z",
    style: {
      fill: "#ffbe9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 86.11,
    width: 167.54,
    height: 279.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.99 250.94 335.78 254.57 339.8 255.16 336.89 257.99 337.58 261.99 333.99 260.1 330.39 261.99 331.08 257.99 328.18 255.16 332.19 254.57 333.99 250.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.93 250.94 355.73 254.57 359.74 255.16 356.84 257.99 357.52 261.99 353.93 260.1 350.34 261.99 351.03 257.99 348.12 255.16 352.14 254.57 353.93 250.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.88 250.94 375.68 254.57 379.69 255.16 376.79 257.99 377.47 261.99 373.88 260.1 370.29 261.99 370.98 257.99 368.07 255.16 372.09 254.57 373.88 250.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.83 250.94 395.63 254.57 399.64 255.16 396.74 257.99 397.42 261.99 393.83 260.1 390.24 261.99 390.93 257.99 388.02 255.16 392.03 254.57 393.83 250.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.78 250.94 415.57 254.57 419.59 255.16 416.68 257.99 417.37 261.99 413.78 260.1 410.19 261.99 410.87 257.99 407.97 255.16 411.98 254.57 413.78 250.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.47,283.75c0,.14-12.72.26-28.41.26s-28.41-.12-28.41-.26,12.72-.26,28.41-.26S366.47,283.6,366.47,283.75Z",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.86,296.08c0,.15-28.37.26-63.35.26s-63.36-.11-63.36-.26,28.36-.26,63.36-.26S437.86,295.94,437.86,296.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.86,306.68c0,.14-28.37.26-63.35.26s-63.36-.12-63.36-.26,28.36-.26,63.36-.26S437.86,306.54,437.86,306.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.86,317.28c0,.14-28.37.26-63.35.26s-63.36-.12-63.36-.26,28.36-.26,63.36-.26S437.86,317.13,437.86,317.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.86,327.88c0,.14-28.37.26-63.35.26s-63.36-.12-63.36-.26,28.36-.26,63.36-.26S437.86,327.73,437.86,327.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.86,338.47c0,.15-28.37.26-63.35.26s-63.36-.11-63.36-.26,28.36-.26,63.36-.26S437.86,338.33,437.86,338.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.56,
    y: 100.32,
    width: 144.32,
    height: 138.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.45,123.28c1.51-5.07,6.15-8.86,11.29-10.09s11.52-2.91,16.23-.51c2.94,1.5,5.76,3.68,6.92,6.77,1.37,3.67-.74,10.51-1.79,14.28s-1.84,8.08.23,11.4,6.14,4.48,8.7,7.3A10.18,10.18,0,0,1,405,166.57c4.55-.27,8.39,4.37,8.23,8.92s-3.49,8.55-7.55,10.61-8.75,2.49-13.3,2.5a80.5,80.5,0,0,1-16.81-1.75c-4.55-1-9.3-2.49-12.26-6.08-2.73-3.3-3.48-7.8-3.49-12.08,0-15.13,7.92-30.13,4.47-44.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,119.8A15,15,0,0,0,344.78,134c.37,3,1.62,6,.86,8.85-1.43,5.43-9.08,7.54-10.08,13.06-.4,2.18.37,4.37.95,6.5s1,4.54-.14,6.46c-.82,1.42-2.3,2.31-3.46,3.46-3.72,3.72-3.65,10.25-.53,14.5s8.64,6.28,13.9,6.11,10.3-2.3,14.79-5.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.09,125.88l.07,3.59.72,53.87c.08,6.26,5.53,11.17,12.22,11h0c6.77-.15,12.26-5.38,12.28-11.7,0-6.63.16-13.61.16-13.61s8.55-1.42,10.32-12.57c.88-5.54.6-14.63.13-22.06a11.77,11.77,0,0,0-13-11Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7,140.76a1.43,1.43,0,0,1-1.38,1.44,1.36,1.36,0,0,1-1.47-1.29,1.42,1.42,0,0,1,1.37-1.44A1.37,1.37,0,0,1,388.7,140.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,139.16c-.18.18-1.26-.62-2.8-.62s-2.67.78-2.83.59.09-.42.59-.78a4,4,0,0,1,2.26-.7,3.8,3.8,0,0,1,2.23.72C390.94,138.73,391.1,139.07,391,139.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.88,140.76a1.43,1.43,0,0,1-1.38,1.44,1.38,1.38,0,0,1-1.47-1.29,1.42,1.42,0,0,1,1.38-1.44A1.36,1.36,0,0,1,373.88,140.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.9,139.44c-.18.19-1.27-.61-2.8-.61s-2.67.78-2.84.59.1-.42.59-.78a4,4,0,0,1,2.27-.7,3.8,3.8,0,0,1,2.23.72C375.82,139,376,139.36,375.9,139.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.48,150.85a10.15,10.15,0,0,1,2.5-.45c.39,0,.76-.12.83-.39a2,2,0,0,0-.26-1.16l-1.17-3c-1.61-4.26-2.78-7.76-2.6-7.83s1.61,3.34,3.23,7.6c.39,1.05.76,2.05,1.11,3a2.21,2.21,0,0,1,.2,1.54,1,1,0,0,1-.64.58,2.88,2.88,0,0,1-.67.09A9.92,9.92,0,0,1,381.48,150.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.54,169.06a28.37,28.37,0,0,1-14.93-4s3.62,7.66,14.78,6.62Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.83,154.56a2.79,2.79,0,0,0-2.49-1,2.49,2.49,0,0,0-1.74.94,1.59,1.59,0,0,0-.13,1.83,1.87,1.87,0,0,0,2,.51,5.92,5.92,0,0,0,2-1.17,2.13,2.13,0,0,0,.44-.46.51.51,0,0,0,0-.57",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,151.92c.25,0,.25,1.65,1.68,2.84s3.21,1,3.22,1.23-.39.33-1.14.35a4.21,4.21,0,0,1-2.69-.94,3.67,3.67,0,0,1-1.31-2.38C376.65,152.32,376.84,151.91,377,151.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.16,120.66c0-.14.18-.21.27-.17s.13.18.07.32a.24.24,0,0,1-.28.16A.23.23,0,0,1,366.16,120.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5,178.62a12.14,12.14,0,0,0,7.12-7.2,16.49,16.49,0,0,0,.24-10.28c-.44-1.55-1.06-3.25-.38-4.71a8.72,8.72,0,0,1,2.43-2.49,10.39,10.39,0,0,0,3.16-7,18,18,0,0,0-1.41-7.71c-.53-1.35-1.17-2.83-.68-4.19a6.43,6.43,0,0,1,1.94-2.35,18.43,18.43,0,0,0,3.87-5.19c.68-1.37,1.19-3,.53-4.41-.81-1.68-2.91-2.2-4.76-2.34-4.42-.34-9.3.64-12.11,4.06-2.51,3.06-2.8,7.33-3,11.3-.56,12.48-1.12,25.09,1,37.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.22,124.64a17.57,17.57,0,0,1-1.91,1,11.93,11.93,0,0,0-1.61,1.4c-.29.28-.6.59-.88.91l-.2.24-.32.32-.77.73a18.31,18.31,0,0,1-2.39,1.88A12.55,12.55,0,0,1,385,133a12.87,12.87,0,0,1-8.46-1,13.2,13.2,0,0,1-4.64-3.72c-1.9-2.53-2.19-4.58-1.32-5.69s3.08-1,5.54-.35a31.15,31.15,0,0,0,3.64.72,8.59,8.59,0,0,0,2.9-.08,6,6,0,0,0,1.35-.48c.63-.28,1.41-.69,2.31-1.12.45-.21.92-.42,1.43-.62.25-.1.52-.19.78-.28s.59-.2.88-.27a9.72,9.72,0,0,1,3.34-.27,6,6,0,0,1,4.56,2.38A1.84,1.84,0,0,1,397.22,124.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.88,186.3a1.83,1.83,0,0,1-.16-.16,5.33,5.33,0,0,1-.42-.52,7.42,7.42,0,0,1-1.13-2.29,8.79,8.79,0,0,1-.2-4,8.1,8.1,0,0,1,2.7-4.6c1.49-1.36,3.44-2.38,5.23-3.8a10.1,10.1,0,0,0,2.36-2.59,5.25,5.25,0,0,0,.75-3.5c-.34-2.52-2.42-4.73-2.6-7.75a7.94,7.94,0,0,1,4.3-7.44,19.71,19.71,0,0,0,3.81-2.17,4.56,4.56,0,0,0,1.53-3.67,10.18,10.18,0,0,0-1-3.92c-.58-1.21-1.28-2.36-1.88-3.53a11.79,11.79,0,0,1-1.26-3.66,7.33,7.33,0,0,1,.45-3.65,10.31,10.31,0,0,1,4.23-4.89,13.83,13.83,0,0,1,5.07-1.77,24.51,24.51,0,0,1,4-.26c1.11,0,2,.08,2.54.13l.66.07c.15,0,.22,0,.22,0a6.51,6.51,0,0,1-.88,0c-.58,0-1.44,0-2.54,0a25.1,25.1,0,0,0-4,.34,13.68,13.68,0,0,0-4.91,1.79,9.94,9.94,0,0,0-4,4.74,6.91,6.91,0,0,0-.4,3.42,11.36,11.36,0,0,0,1.24,3.51c.59,1.15,1.3,2.29,1.9,3.54a10.41,10.41,0,0,1,1.09,4.12,5,5,0,0,1-1.69,4.06,19.4,19.4,0,0,1-3.91,2.25,7.44,7.44,0,0,0-4,7c.13,2.78,2.18,5,2.56,7.7a5.68,5.68,0,0,1-.83,3.81,10.51,10.51,0,0,1-2.48,2.69c-1.86,1.45-3.8,2.43-5.25,3.73a7.77,7.77,0,0,0-2.66,4.38,8.6,8.6,0,0,0,.11,3.93A9.72,9.72,0,0,0,340.88,186.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.08,184.15a2,2,0,0,0,1-1.21,2.82,2.82,0,0,0-.13-1.81,4.39,4.39,0,0,0-1.65-1.78c-.77-.53-1.72-.95-2.67-1.6a4.22,4.22,0,0,1-2-3,6,6,0,0,1,1.27-3.82c.8-1.15,1.84-2.13,2.64-3.29a5.18,5.18,0,0,0,1-3.8,8.12,8.12,0,0,0-1.53-3.45c-1.44-2-3.23-3.46-4.36-5a8.61,8.61,0,0,1-1.91-4.09,4.41,4.41,0,0,1,0-1.23c0-.28.08-.43.1-.42a10.81,10.81,0,0,0,.09,1.62,8.77,8.77,0,0,0,2,3.89c1.14,1.49,2.94,2.9,4.46,5a8.57,8.57,0,0,1,1.64,3.66,5.32,5.32,0,0,1-.12,2.17,6.46,6.46,0,0,1-1,2c-.84,1.23-1.89,2.21-2.66,3.29a5.58,5.58,0,0,0-1.2,3.49,3.79,3.79,0,0,0,1.79,2.71c.89.63,1.84,1.08,2.62,1.64a4.65,4.65,0,0,1,1.72,2,2.88,2.88,0,0,1,.05,2,1.81,1.81,0,0,1-.75,1A.81.81,0,0,1,403.08,184.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,120.08s0,.12,0,.35a4.88,4.88,0,0,1-.11,1,6.35,6.35,0,0,1-1.73,3.23,6.26,6.26,0,0,1-5.07,1.83,6.41,6.41,0,0,1-3.1-1.07,13.31,13.31,0,0,1-2.48-2.44,12.47,12.47,0,0,0-2.41-2.31,10.27,10.27,0,0,0-2.78-1.37,9.94,9.94,0,0,0-5.21-.19,10.83,10.83,0,0,0-3.29,1.39c-.72.46-1.08.77-1.1.74a3.91,3.91,0,0,1,1-.91,9.72,9.72,0,0,1,3.31-1.57,10,10,0,0,1,5.44.08,10.66,10.66,0,0,1,2.93,1.41,12.65,12.65,0,0,1,2.52,2.39,13.22,13.22,0,0,0,2.37,2.36,6.15,6.15,0,0,0,2.85,1,6,6,0,0,0,4.78-1.62,6.6,6.6,0,0,0,1.79-3C397.92,120.56,397.92,120.08,398,120.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.29,133.41c-.15.42-1.69.22-3.49.44s-3.26.71-3.5.34c-.11-.18.14-.58.73-1a6.12,6.12,0,0,1,5.33-.59C376,132.89,376.36,133.22,376.29,133.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.45,134.7c-.27.35-1.33,0-2.6,0s-2.36.24-2.61-.13c-.1-.18.07-.53.54-.86a3.57,3.57,0,0,1,2.12-.57,3.66,3.66,0,0,1,2.07.7C390.42,134.17,390.57,134.53,390.45,134.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.9,239.32c.54.93-3.41-12.38-3.41-12.38l-3.31,12.16-24.55.18s13.87-45.34,20.46-51.67c8.6-8.26,24.72-8.71,24.72-8.71l9.65,8.23,15.24-7.83.56.06A30.52,30.52,0,0,1,409.83,196l16.53,42.83H404.54l-4.66-12.64,1.56,12.64",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,179.88l22.12,50.32,11.18-50.84s-3.1-.18-7.53-.35c-2.45-.09-5.31,9.6-8.27,9.55-1.9,0-3.83-9.83-5.74-9.82-2.41,0-4.76,0-6.9.16C356,179,354.37,179.75,353,179.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.16,180.35v-4.62s13.18.18,13.41,10.73c0,0,1.87-10.4,12.51-10.73l.68,3.54-3,12.13-7.68,5.11H362.73l-4.28-5.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,231.54a2.26,2.26,0,0,1,.13-.56,9.48,9.48,0,0,1,.64-1.54,10.27,10.27,0,0,1,1.56-2.13c.7-.76,1.54-1.56,2.39-2.51a36.64,36.64,0,0,0,5.5-7.08,11.78,11.78,0,0,0,1.41-5,7.83,7.83,0,0,0-1.53-5.24l-.35-.45.58,0a3.06,3.06,0,0,0,.67,0,3.88,3.88,0,0,0,2.31-1.46,5.29,5.29,0,0,0,1.05-2.53,17.72,17.72,0,0,0-.41-5.36c-.57-3.44-1.09-6.54-1.52-9.17s-.74-4.65-1-6.18c-.09-.69-.17-1.24-.24-1.69a3.23,3.23,0,0,1-.05-.59,2.78,2.78,0,0,1,.16.58c.08.43.2,1,.33,1.66.29,1.53.68,3.61,1.15,6.16l1.63,9.14a17.52,17.52,0,0,1,.44,5.53,5.64,5.64,0,0,1-1.15,2.77,4.32,4.32,0,0,1-2.63,1.65,3.55,3.55,0,0,1-.79,0l.22-.42a8.27,8.27,0,0,1,1.63,5.58,12.11,12.11,0,0,1-1.5,5.21,35.73,35.73,0,0,1-5.65,7.11c-.88.94-1.74,1.73-2.45,2.46a10.7,10.7,0,0,0-1.6,2C375.17,230.77,375,231.56,374.93,231.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,231.11a2.38,2.38,0,0,1-.41-.46l-1.13-1.35c-1-1.17-2.43-2.83-4.26-4.85s-4-4.43-6.23-7.31a25.85,25.85,0,0,1-3.09-4.8,8,8,0,0,1-.37-6.11,5.67,5.67,0,0,1,.39-.78l.13.38A11.81,11.81,0,0,1,355,202.4a15.71,15.71,0,0,1-2.84-4.8,22.6,22.6,0,0,1-1.23-9.26,55.54,55.54,0,0,1,.75-6.24c.13-.68.23-1.23.32-1.67a2.27,2.27,0,0,1,.14-.58,2.7,2.7,0,0,1,0,.6c-.06.44-.13,1-.22,1.68-.18,1.47-.49,3.59-.58,6.23a22.58,22.58,0,0,0,1.3,9.07,15.48,15.48,0,0,0,2.78,4.64,11.41,11.41,0,0,0,4.72,3.27l.29.1-.16.28a7.61,7.61,0,0,0-.35.7,7.53,7.53,0,0,0,.36,5.71,25,25,0,0,0,3,4.72c2.16,2.87,4.33,5.29,6.12,7.35s3.21,3.76,4.14,5c.47.61.82,1.08,1.05,1.42A2.69,2.69,0,0,1,374.93,231.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,239.21a19.43,19.43,0,0,1-.15-4.51,20.44,20.44,0,0,1,.38-4.49,39.83,39.83,0,0,1-.23,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.85,229.94a14.26,14.26,0,0,1,.43-1.73c.29-1.11.71-2.72,1.11-4.73a66.06,66.06,0,0,0,1.2-15.9,41.64,41.64,0,0,0-1.18-8.68,16.47,16.47,0,0,0-3.11-6.35,12.37,12.37,0,0,0-3.64-3.08c-1-.54-1.63-.71-1.61-.76a2.16,2.16,0,0,1,.45.1,7.67,7.67,0,0,1,1.25.48,11.71,11.71,0,0,1,3.84,3,16.78,16.78,0,0,1,3.29,6.46,40.87,40.87,0,0,1,1.23,8.79,61.08,61.08,0,0,1-1.36,16c-.45,2-.92,3.61-1.27,4.71-.18.54-.34,1-.44,1.25S342.87,230,342.85,229.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.07,221.79a11.09,11.09,0,0,1-.07-1.67c0-1.08,0-2.63-.1-4.55a141.22,141.22,0,0,0-1.31-14.93,150.75,150.75,0,0,0-4.21-19.45l-.07-.26.2.16a6.94,6.94,0,0,1,1,.85,7.2,7.2,0,0,1-1.09-.71l.14-.09a109.33,109.33,0,0,1,4.55,19.43,115.89,115.89,0,0,1,1.17,15c0,1.93,0,3.49-.07,4.56A9.74,9.74,0,0,1,400.07,221.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.12,180.48c0,.05-.25,0-.59.27a3.54,3.54,0,0,0-1,1.41,16,16,0,0,0-1.75,5.84l-.07.65-.4-.53-.72-1c-1.67-2.17-3.31-4-4.52-5.36a19.3,19.3,0,0,1-1.93-2.18,13.39,13.39,0,0,1,2.2,1.93,52.17,52.17,0,0,1,4.66,5.29l.73,1-.47.12a14.77,14.77,0,0,1,2-5.94,3.46,3.46,0,0,1,1.26-1.42C367.85,180.37,368.13,180.46,368.12,180.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.59,179.49a16.72,16.72,0,0,1-1.77,2.45c-1.14,1.48-2.75,3.5-4.55,5.71l-.95,1.16-.44.54,0-.7a21.24,21.24,0,0,0-.25-3.43,7.08,7.08,0,0,0-.94-2.53,6.77,6.77,0,0,0-1.72-1.77,1.52,1.52,0,0,1,.64.27A4.5,4.5,0,0,1,375,182.5a7.05,7.05,0,0,1,1.1,2.64,19.12,19.12,0,0,1,.32,3.5l-.46-.15.95-1.17c1.8-2.21,3.45-4.19,4.67-5.61A17.36,17.36,0,0,1,383.59,179.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.49,229a11.32,11.32,0,0,1-.24-1.67c-.13-1.17-.29-2.7-.49-4.56-.39-3.86-.88-9.19-1.4-15.08s-1-11.22-1.26-15.09c-.13-1.86-.23-3.4-.32-4.57a9.9,9.9,0,0,1,0-1.69,12,12,0,0,1,.25,1.67c.12,1.17.28,2.7.48,4.56.39,3.86.89,9.19,1.41,15.08s1,11.22,1.25,15.08c.13,1.87.24,3.41.32,4.58A9.9,9.9,0,0,1,374.49,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.52,195.53c0-.05.37-.3.91.06a1.2,1.2,0,0,1,.52.95,1.22,1.22,0,0,1-2.13.69,1.18,1.18,0,0,1-.14-1.07c.23-.61.71-.65.7-.59s-.27.23-.34.68a.84.84,0,0,0,.16.68.7.7,0,0,0,.75.17.71.71,0,0,0,.52-.58.86.86,0,0,0-.27-.64C374.87,195.55,374.53,195.61,374.52,195.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.44,208c0-.06.44-.22.89.26a1.17,1.17,0,0,1,.3,1.06,1.15,1.15,0,0,1-1.1.82,1.13,1.13,0,0,1-1.16-.72,1.17,1.17,0,0,1,.2-1.09c.41-.51.9-.39.86-.33s-.34.12-.55.54a.84.84,0,0,0-.06.71.68.68,0,0,0,.69.37.69.69,0,0,0,.66-.43.89.89,0,0,0-.12-.7C376.79,208.05,376.44,208,376.44,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351.7,180.48c-1.87,6.65-3.64,14.18-.16,20.15,1,1.8,2.52,3.33,3.5,5.17,1.69,3.15,1.8,6.89,2.85,10.3,2.11,6.91,9.65,13.63,16.8,14.68-3.69-4.49-9.4-10.34-12.8-15.43a12.48,12.48,0,0,1-2.34-4.51c-.42-1.85-.73-3.81.5-5.26-4.78-.74-7.5-5.68-8.36-10.44a35.29,35.29,0,0,1,.59-14.39"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400.27,215.85c-1.19,7.14-.39,16.5,4,22.26,1.61-7.84.81-18.09-4-24.52"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.87,
    y: 128.3,
    width: 117.54,
    height: 196.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.05 243.94 198.31 246.49 201.13 246.9 199.09 248.88 199.57 251.69 197.05 250.37 194.53 251.69 195.02 248.88 192.98 246.9 195.79 246.49 197.05 243.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.05 243.94 212.31 246.49 215.13 246.9 213.09 248.88 213.57 251.69 211.05 250.37 208.53 251.69 209.01 248.88 206.97 246.9 209.79 246.49 211.05 243.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.04 243.94 226.3 246.49 229.12 246.9 227.08 248.88 227.56 251.69 225.04 250.37 222.53 251.69 223.01 248.88 220.97 246.9 223.78 246.49 225.04 243.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.04 243.94 240.3 246.49 243.12 246.9 241.08 248.88 241.56 251.69 239.04 250.37 236.52 251.69 237 248.88 234.96 246.9 237.78 246.49 239.04 243.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.03 243.94 254.29 246.49 257.11 246.9 255.07 248.88 255.55 251.69 253.03 250.37 250.51 251.69 251 248.88 248.96 246.9 251.78 246.49 253.03 243.94",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84,267c0,.14-8.92.26-19.93.26S180,267.1,180,267s8.93-.26,19.93-.26S219.84,266.81,219.84,267Z",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,275.61c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.26,44.45-.26S269.93,275.47,269.93,275.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,283.05c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.27,44.45-.27S269.93,282.9,269.93,283.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,290.48c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.26,44.45-.26S269.93,290.34,269.93,290.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,297.92c0,.14-19.9.26-44.45.26s-44.45-.12-44.45-.26,19.9-.26,44.45-.26S269.93,297.77,269.93,297.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,305.35c0,.15-19.9.26-44.45.26S181,305.5,181,305.35s19.9-.26,44.45-.26S269.93,305.21,269.93,305.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.42,
    y: 138.27,
    width: 101.25,
    height: 97.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.26,186.44c0,2.53.23,4,.25,6.55a2.23,2.23,0,0,0,.55,1.75,1.44,1.44,0,0,0,1.51.07,3.85,3.85,0,0,0,1.18-1.06,22,22,0,0,0,4.85-12.12,1.45,1.45,0,0,0-.21-1.09c-.4-.46-1.14-.29-1.69,0a13.77,13.77,0,0,0-6.44,5.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.26,156.2l.05,2.52.51,37.8a8.11,8.11,0,0,0,8.57,7.73h0c4.75-.1,8.6-3.77,8.62-8.21,0-4.65.11-9.55.11-9.55s6-1,7.24-8.81c.61-3.89.42-10.27.09-15.48a8.26,8.26,0,0,0-9.11-7.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,166.64a1,1,0,0,1-1,1,1,1,0,0,1-1-.9,1,1,0,0,1,1-1A1,1,0,0,1,235.44,166.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.07,165.51c-.13.14-.89-.43-2-.42s-1.87.54-2,.41.06-.3.41-.55a2.78,2.78,0,0,1,1.59-.49,2.62,2.62,0,0,1,1.56.5C237,165.22,237.13,165.46,237.07,165.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,166.64a1,1,0,0,1-1,1,1,1,0,0,1-1-.9,1,1,0,0,1,1-1A1,1,0,0,1,225,166.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.46,165.72c-.13.13-.89-.44-2-.43s-1.87.54-2,.41.06-.3.41-.55a2.78,2.78,0,0,1,1.59-.49,2.62,2.62,0,0,1,1.56.51C226.4,165.42,226.52,165.66,226.46,165.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,173.72a7.3,7.3,0,0,1,1.76-.32c.27,0,.53-.08.58-.27a1.44,1.44,0,0,0-.18-.81c-.26-.67-.53-1.37-.82-2.1a36.63,36.63,0,0,1-1.83-5.49,35.48,35.48,0,0,1,2.27,5.33l.78,2.11a1.62,1.62,0,0,1,.14,1.08.64.64,0,0,1-.45.4,1.73,1.73,0,0,1-.47.07A7,7,0,0,1,230.37,173.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.12,186.49a19.89,19.89,0,0,1-10.47-2.79s2.54,5.37,10.36,4.64Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.92,176.32a2,2,0,0,0-1.75-.72,1.78,1.78,0,0,0-1.22.66,1.1,1.1,0,0,0-.09,1.28,1.3,1.3,0,0,0,1.42.36,4.14,4.14,0,0,0,1.38-.82,1.57,1.57,0,0,0,.31-.32.36.36,0,0,0,0-.4",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.2,174.47c.17,0,.18,1.16,1.18,2s2.25.7,2.26.87-.28.22-.81.24a2.89,2.89,0,0,1-1.88-.66,2.51,2.51,0,0,1-.92-1.67C227,174.75,227.12,174.46,227.2,174.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,155.55a3.54,3.54,0,0,1,2,1.51,16.83,16.83,0,0,0,1.5,2.05,4.52,4.52,0,0,0,5.25.8c.63.61,1.46,1.26,2.3,1a1.5,1.5,0,0,0,.92-1.14,2.59,2.59,0,0,0-.22-1.5c-.82-1.91-2.93-2.93-5-3.33a14.1,14.1,0,0,0-7.45.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,235.79c.37.65-2.4-8.69-2.4-8.69l-2.32,8.53-17.22.13s9.73-31.81,14.35-36.25c6-5.8,17.34-6.11,17.34-6.11l17.47.28.39,0a21.42,21.42,0,0,1,16.54,11.7l11.59,30.05H246.55l-3.26-8.87,1.09,8.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,192.65c-.53-1.26-2.45-1.21-3.29-2.28s-.11-2.84.58-4.17c3.31-6.38,3-14,2.37-21.14-.26-3.07-.57-6.2-1.9-9-2.65-5.54-9.06-9.92-17-9.56-6.49.25-11.43,6.1-14.94,11.57s-5.38,14-4.23,20.43c.58,3.2,4,5.67,3.4,8.86-.4,2-2.5,4.42-2.09,6.43.56,2.74,4.54,3.69,6.87,5.25a51.37,51.37,0,0,1,6.49,5.68,20.53,20.53,0,0,0,7.13,4.76c2.73.92,6,.75,8.2-1.08,3.63-3,3.28-8.93,6.58-12.27C240.36,195.14,241.78,194,241.23,192.65Zm-5.12-34.58c1.33,2,1.44,4.59,1.75,7a41.39,41.39,0,0,1,.14,12.17A19.11,19.11,0,0,1,232.69,188a12.53,12.53,0,0,1-11.22,3.4c-4.45-1-5.88-5-7.14-9.35s1.55-8.4,2.8-12.79c1-3.39,1.33-8.17,3.52-10.93s5.82-2.95,6.89-2.9C227.54,155.42,233.44,154.05,236.11,158.07Z",
    style: {
      fill: "#EE9322"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.53,190.58c2.64,1.43,4.71,3.7,6.86,5.8s4.54,4.14,7.45,4.89,6.45-.14,7.9-2.77a18.58,18.58,0,0,1-20-11.68"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.51,188.71a7.7,7.7,0,0,1-3.91,4.87,5.09,5.09,0,0,0-1.26.74,1.23,1.23,0,0,0-.39,1.32,1.2,1.2,0,0,0,1.42.52,3.53,3.53,0,0,0,1.34-.93c1.44-1.39,2.94-2.9,3.35-4.86"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-14"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 589.24,
    cy: 232.63,
    r: 14.65,
    transform: "translate(226.68 752.12) rotate(-76.63)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587,238.87a14.32,14.32,0,0,1,2.05-1.91c1.32-1.12,3.16-2.65,5.22-4.32v.4l-.1-.09c-2-1.76-3.84-3.37-5.14-4.56a15.21,15.21,0,0,1-2-2,16.36,16.36,0,0,1,2.26,1.72c1.36,1.12,3.21,2.69,5.24,4.45l.1.08.24.21-.25.19c-2.05,1.67-3.93,3.16-5.3,4.21A16.65,16.65,0,0,1,587,238.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.75,
    cy: 232.63,
    r: 14.65,
    transform: "matrix(0.23, -0.97, 0.97, 0.23, -104.13, 333.69)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,226.39a16.07,16.07,0,0,1-2.06,1.9c-1.32,1.13-3.15,2.66-5.21,4.33v-.4l.11.09c2,1.76,3.84,3.37,5.13,4.56a15,15,0,0,1,2,2,15.72,15.72,0,0,1-2.27-1.73c-1.36-1.11-3.21-2.68-5.23-4.44l-.11-.09-.23-.2.24-.2c2.06-1.66,3.94-3.15,5.31-4.2A14.42,14.42,0,0,1,161,226.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.55,89.25A112.41,112.41,0,0,0,338.37,296h0a112.32,112.32,0,0,0,102.07-18.95l94.73,118.5L549.66,384l-95.53-119.5a111.9,111.9,0,0,0,24.64-43,113.33,113.33,0,0,0,2.94-11.82A112.42,112.42,0,0,0,318.55,89.25Zm80.21,9.53a93.87,93.87,0,1,1-71.51,6.86A93.25,93.25,0,0,1,398.76,98.78Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerSection);
export default __webpack_public_path__ + "static/media/career-section.90f0d4bb4d71604a5a9a1f291ae4e353.svg";
export { ForwardRef as ReactComponent };